/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Sort order by creation time. Defaults to 'desc' (newest first).
 */
export const ListSpeechToTextHistoryQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * Sort order by creation time. Defaults to 'desc' (newest first).
 */
export type ListSpeechToTextHistoryQueryParamOrder = ClosedEnum<
  typeof ListSpeechToTextHistoryQueryParamOrder
>;

export type ListSpeechToTextHistoryRequest = {
  after?: string | undefined;
  limit?: number | undefined;
  /**
   * Sort order by creation time. Defaults to 'desc' (newest first).
   */
  order?: ListSpeechToTextHistoryQueryParamOrder | undefined;
  model?: string | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListSpeechToTextHistoryQueryParamOrder$inboundSchema:
  z.ZodNativeEnum<typeof ListSpeechToTextHistoryQueryParamOrder> = z.nativeEnum(
    ListSpeechToTextHistoryQueryParamOrder,
  );
/** @internal */
export const ListSpeechToTextHistoryQueryParamOrder$outboundSchema:
  z.ZodNativeEnum<typeof ListSpeechToTextHistoryQueryParamOrder> =
    ListSpeechToTextHistoryQueryParamOrder$inboundSchema;

/** @internal */
export const ListSpeechToTextHistoryRequest$inboundSchema: z.ZodType<
  ListSpeechToTextHistoryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListSpeechToTextHistoryQueryParamOrder$inboundSchema.default("desc"),
  model: z.string().optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListSpeechToTextHistoryRequest$Outbound = {
  after?: string | undefined;
  limit: number;
  order: string;
  model?: string | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListSpeechToTextHistoryRequest$outboundSchema: z.ZodType<
  ListSpeechToTextHistoryRequest$Outbound,
  z.ZodTypeDef,
  ListSpeechToTextHistoryRequest
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListSpeechToTextHistoryQueryParamOrder$outboundSchema.default("desc"),
  model: z.string().optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listSpeechToTextHistoryRequestToJSON(
  listSpeechToTextHistoryRequest: ListSpeechToTextHistoryRequest,
): string {
  return JSON.stringify(
    ListSpeechToTextHistoryRequest$outboundSchema.parse(
      listSpeechToTextHistoryRequest,
    ),
  );
}
export function listSpeechToTextHistoryRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListSpeechToTextHistoryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSpeechToTextHistoryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSpeechToTextHistoryRequest' from JSON`,
  );
}
